module.exports = __webpack_public_path__ + "assets/headPortrait.f03405ec.svg";